import renderPercentageValue from './renderPercentageValue';

export default function renderPercentage(value: any, difference = 0) {
  return `${renderPercentageValue(value)} ${difference===0?'':'('+(difference<0?'-':'+')+renderPercentageValue(difference)+') '}%`
}